import { useMemo } from 'react';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { fallbackMenu, type MenuType } from '../../interface/Menu';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetMenu = () => {
  const { data: session } = useSession();

  const url = useMemo(() => {
    if (session?.access_token) {
      return apiConfig.routes.menu.getMenu;
    }

    return apiConfig.routes.menu.getMenuPublic;
  }, [session]);

  return useQuery({
    queryKey: ['customer', 'menu', url],
    queryFn: () => getMenu(url, session?.access_token),
  });
};

const getMenu = async (url: string, accessToken?: string) => {
  try {
    const { data } = await api.get<{ data: MenuVersionsProps }>(url, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });

    return data.data.items;
  } catch {
    return fallbackMenu;
  }
};

type MenuVersionsProps = {
  name: string;
  default: boolean;
  items: MenuType[];
};
